module.exports = __webpack_public_path__ + "img/NORDICBET.a3cff6ac.svg";